interface TopicBadgeProps {
  topic: string;
}

export default function TopicBadge({ topic }: TopicBadgeProps) {
  return (
    <span
      className="inline-flex items-center rounded-lg border border-slate-200/70 bg-slate-50/60 px-2 py-1 text-xs font-medium text-blue-700 dark:border-white/10 dark:bg-white/5 dark:text-blue-300"
    >
      {topic}
    </span>
  );
}
